import React, { Component } from 'react';
import Tab from '../../common/tab';
import Index from './index2';
import Prospect from './prospect';
import Valuation from './valuation';
import Liquidity from './liquidity';
import MarketAnomaly from './market-anomaly';
import currentState from './../../helpers/CurrentState';
import ConstCommon from './../../common/Const';
import { COMPONENT_RESIZE } from '../../common/GoldenLayoutWrapper';
import ScrollComponent from '../../common/ScrollComponent';

class MainContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentTab:
        props.tab ||
        currentState.get(
          ConstCommon.listComponent.MarketInDepth,
          'currentTab',
        ) ||
        1,
      widthScroll: 1,
    };
    this.scrollRef = React.createRef();
    this.mainRef = React.createRef();
  }

  changeTab = currentTab => {
    currentState.add(
      ConstCommon.listComponent.MarketInDepth,
      'currentTab',
      currentTab,
    );
    this.setState({ currentTab });
  };

  renderContentTab = () => {
    const { currentTab } = this.state;

    switch (currentTab) {
      case 1:
        return <Prospect />;
      case 2:
        return <Index />;
      case 3:
        return <Valuation />;
      case 4:
        return <Liquidity />;
      case 5:
        return <MarketAnomaly />;
      default:
        return <Index />;
    }
  };

  renderTab = () => {
    const { currentTab } = this.state;

    return (
      <Tab
        currentTab={currentTab}
        listTab="marketInDepthCommon.tab"
        changeTab={this.changeTab}
      />
    );
  };

  changeWidthScroll = () => {
    if (this.scrollRef.current) {
      this.setState({ widthScroll: this.scrollRef.current.scrollWidth });
    }
  };

  componentDidMount() {
    this.changeWidthScroll();
    window.addEventListener(COMPONENT_RESIZE, this.changeWidthScroll);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { currentTab } = this.state;
    if (prevState.widthScroll !== this.scrollRef.current.scrollWidth) {
      this.changeWidthScroll();
    }
    if (currentTab !== prevState.currentTab) {
      this.mainRef.current.scrollToTop();
    }
  }

  componentWillUnmount() {
    window.removeEventListener(COMPONENT_RESIZE, this.changeWidthScroll);
  }

  render() {
    return (
      <ScrollComponent scrollRef={this.mainRef}>
        <div
          className="top-nav pt-8 sticky"
          style={{ width: this.state.widthScroll, zIndex: 7 }}
        >
          <div className="px-20">{this.renderTab()}</div>
        </div>
        <div className="flex-fill d-flex flex-column h-100">
          <div
            className="top-nav tab-content flex-fill d-flex flex-column h-auto"
            ref={this.scrollRef}
          >
            <div className="d-flex flex-fill flex-column">
              {this.renderContentTab()}
            </div>
          </div>
        </div>
      </ScrollComponent>
    );
  }
}

export default MainContent;
